/**
 *
 * - This goes into <td> of "student" column and display
 *   an avatar, student's name and age
 *
 * @parent Table (but passed by student-table-field)
 * @stateless
 */
import React, { PropTypes } from 'react';
//
import { Link } from 'react-router'
import ContactInfoDock from 'template/Docks/ContactInfo';
import __R, { userCan } from 'containers/__R'

const MALE_IMG = require('data/images/Male_student.png');
const FEMALE_IMG = require('data/images/Female_student.png');
const NEUTRAL_IMG = require('data/images/default-logo.png');

class ClientInfoTD extends React.Component {
  constructor(props) {
		super(props);
	}

	static propTypes = {
		client: PropTypes.object.isRequired
	}

	render() {
		let { client, fetchClientList } = this.props;

		let {
			name,
			gender,
      contact_id
		} = client;

    let image
    if (gender == 0){
      image = `url(${MALE_IMG})`
    } else if (gender == 1){
      image = `url(${FEMALE_IMG})`
    } else if (gender == 3){
      image = `url(${NEUTRAL_IMG})`
    }

		return (
			<div className='client-info-container'>
				<div className="portrait" style={{
					backgroundImage: image
        }}>
				</div>
				<div className="text-container">
					<div className="name">
            <__R can='read_contact_detail' by='disable'>
							<button className='btn-link' style={{cursor: 'pointer'}} 
								onClick={() => {
									ContactInfoDock({id: contact_id, name})
										.then((res)=>{
											fetchClientList();
										})
								}}>{name}</button>
            </__R>
					</div>
				</div>
			</div>
		);
  }
}

export default ClientInfoTD;



// WEBPACK FOOTER //
// ./src/containers/pages/PotentialClient/ClientInfoTD.js